import { thunk } from 'easy-peasy';
import api from '~/services/api';
import { IThunkRemoveIcd10Code } from '../types';

// @ts-ignore
const onRemoveIcd10Code: IThunkRemoveIcd10Code = thunk(async ({ removeIcd10Code }, id) => {
  await api.icd10Codes.remove(id);
  removeIcd10Code(id);
});

export default onRemoveIcd10Code;
